function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["name", "defaultValue", "value", "validations", "onBlur", "onChange", "subText", "subTextOnValid", "subTextOnInvalid", "state"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import { Input } from "@xo-union/ui-form-validations";
var wrapComponent = function wrapComponent(Component) {
  var WithValidation = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var name = props.name,
      defaultValue = props.defaultValue,
      value = props.value,
      validations = props.validations,
      onBlur = props.onBlur,
      onChange = props.onChange,
      subText = props.subText,
      subTextOnValid = props.subTextOnValid,
      subTextOnInvalid = props.subTextOnInvalid,
      state = props.state,
      restOfProps = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/React.createElement(Input, {
      ref: ref,
      name: name,
      value: value,
      defaultValue: defaultValue,
      onBlur: onBlur,
      onChange: onChange,
      subText: subText,
      subTextOnValid: subTextOnValid,
      subTextOnInvalid: subTextOnInvalid,
      state: state,
      validations: validations
    }, function (validationProps, data) {
      var finalProps = _objectSpread(_objectSpread(_objectSpread({}, restOfProps), validationProps), {}, {
        state: data.state,
        subText: data.subText
      });
      return /*#__PURE__*/React.createElement(Component, finalProps);
    });
  });
  WithValidation.displayName = "WithValidation(".concat(Component.displayName || Component.name || 'Component', ")");
  process.env.NODE_ENV !== "production" ? WithValidation.propTypes = {
    name: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    validations: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    subText: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    subTextOnValid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    subTextOnInvalid: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    state: PropTypes.string
  } : void 0;
  return WithValidation;
};
export default wrapComponent;